import React from 'react';
import PropTypes from 'prop-types';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';
import { FirstIcon, LastIcon, NextIcon, PreviousIcon } from '../Icons/Icons';

import './pagination.scss';

class Pagination extends React.Component {
    constructor(props) {
        super(props);

        this.onFirst = this.onFirst.bind(this);
        this.onLast = this.onLast.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onPrevious = this.onPrevious.bind(this);
    }
    onFirst() {
        const { onPageChange } = this.props;

        if (this.hasPrevious()) {
            onPageChange(1);
            this.handleScrollTop();
        }
    }

    onLast() {
        const { onPageChange, total } = this.props;

        if (this.hasNext()) {
            onPageChange(total);
            this.handleScrollTop();
        }
    }

    onNext() {
        const { onPageChange, current } = this.props;

        if (this.hasNext()) {
            onPageChange(current + 1);
            this.handleScrollTop();
        }
    }

    onPrevious() {
        const { onPageChange, current } = this.props;

        if (this.hasPrevious()) {
            onPageChange(current - 1);
            this.handleScrollTop();
        }
    }

    hasNext() {
        const { current, total } = this.props;

        return current < total;
    }

    hasPrevious() {
        const { current } = this.props;

        return current > 1;
    }

    handleScrollTop = () => {
        window.scrollTo(0, 0);
    }

    render() {
        const { current, isDisabled, total } = this.props;
        const isNextDisabled = !this.hasNext() || isDisabled;
        const isPreviousDisabled = !this.hasPrevious() || isDisabled;

        return (
            <div className="pagination">
                <button
                    className="pagination__control"
                    disabled={isPreviousDisabled}
                    onClick={this.onFirst}
                    type="button"
                >
                    <VisuallyHidden>First</VisuallyHidden>
                    <FirstIcon size={11} />
                </button>
                <button
                    className="pagination__control"
                    disabled={isPreviousDisabled}
                    onClick={this.onPrevious}
                    type="button"
                >
                    <VisuallyHidden>Previous</VisuallyHidden>
                    <PreviousIcon height={11} width={7} />
                </button>
                <div className="pagination__info">{current} of {total}</div>
                <button
                    className="pagination__control"
                    disabled={isNextDisabled}
                    onClick={this.onNext}
                    type="button"
                >
                    <VisuallyHidden>Next</VisuallyHidden>
                    <NextIcon height={11} width={7} />
                </button>
                <button
                    className="pagination__control"
                    disabled={isNextDisabled}
                    onClick={this.onLast}
                    type="button"
                >
                    <VisuallyHidden>Last</VisuallyHidden>
                    <LastIcon size={11} />
                </button>
            </div>
        );
    }
}

Pagination.propTypes = {
    current: PropTypes.number,
    isDisabled: PropTypes.bool,
    onPageChange: PropTypes.func.isRequired,
    total: PropTypes.number,
};

Pagination.defaultProps = {
    current: 0,
    isDisabled: false,
    total: 0,
};

export default Pagination;
